import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
}

// Define the component
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Show a loading indicator while checking auth status
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark">
        Checking authentication...
      </div>
    );
  }

  if (!isAuthenticated) {
    // User not authenticated, redirect to login page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render the child components
  return <>{children}</>;
};

// Export the component as default
export default ProtectedRoute;

// Add empty export to ensure the file is treated as a module
export {};
